'use client'

import { Builder } from '@builder.io/react'

import { SocialLadderIframe } from './SocialLadderIframe'

Builder.registerComponent(SocialLadderIframe, {
  name: 'SocialLadderIframe',
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/circle-letter-s.svg',
  inputs: [
    {
      name: 'flow',
      type: 'enum',
      enum: ['affiliateApplication'],
      defaultValue: 'affiliateApplication',
      required: true,
    },
  ],
})
